import axios from 'axios'

export const api = axios.create({
	baseURL: 'http://3.90.201.91/api/v1',
	header: {
		"Content-Type": "application/json",
	}
});
export const userKey = 'auth_user'
export const userCart = 'user_cart'

export default { api, userKey, userCart };
